@if (product$ | async; as product) {
  <div class="grid gap-10 lg:grid-cols-2">
    <app-public-product-images-galleria [files]="product.files" />

    <div>
      <div class="font-['Poppins'] text-4xl font-bold uppercase">
        {{ product.name }}
      </div>

      <div class="mt-10">
        @for (attribute of product.attributes; track attribute.id) {
          <div class="flex gap-1">
            <span class="font-bold">{{ attribute.label }}:</span>
            <app-summernote-html-preview [html]="attribute.content" />
          </div>
        }
      </div>

      @if (isNotNil(product.cosmeticBrand)) {
        <div class="mt-5">
          <app-router-link
            class="inline-flex"
            [route]="Route.PL_BrandDetails"
            [params]="cosmeticDetailsParams(product.cosmeticBrand.slug)">
            <app-image-thumbnail
              [rounded]="false"
              size="lg">
              <img
                [fill]="true"
                [ngSrc]="product.cosmeticBrand.logo.url"
                [alt]="product.cosmeticBrand.logo.url"
                class="object-contain"
                loading="lazy" />
            </app-image-thumbnail>
          </app-router-link>
        </div>
      }

      <div class="mt-10">
        <p-accordion
          [multiple]="true"
          [value]="[0]">
          @for (
            characteristic of product.characteristics;
            track characteristic.id;
            let index = $index
          ) {
            <p-accordion-panel [value]="index">
              <p-accordion-header>
                {{ characteristic.label }}
              </p-accordion-header>

              <p-accordion-content>
                <p class="m-0">
                  <app-summernote-html-preview
                    [html]="characteristic.content" />
                </p>
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      </div>

      <div class="mt-10">
        <div class="flex items-center gap-4">
          @if (product.sales.isAvailable()) {
            <div>
              <app-public-cart-quantity
                (quantityChangeEvent)="handleQuantityChangeEvent($event)" />
            </div>
          }

          <app-public-cart-add-button
            label="Kup produkt"
            theme="primary"
            [quantity]="quantity()"
            [sales]="product.sales" />
        </div>
      </div>
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
